import { FundWithDetailsEntity } from '@/src/lib/MayzSmartDB';
import { useTokensStore, useWalletStore } from '@/src/store/global';
import { getNumberx1e6 } from '@/src/lib/MayzSmartDB';
import { formatPercentage } from '@/src/lib/SmartDB/Commons/formatters';
import {
    showADA_Amount_Rounded,
    showTokenGov_Amount_Rounded,
    showToken_Amount_Rounded,
    showToken_Price_MultipliedByAmount_Rounded,
} from '@/src/store/global/tokensStoreModelHelpers';
import { useEffect, useState } from 'react';
import MoreDetailsHome from './MoreDetailsHome';
import styles from './RowDetailsHome.module.scss';
import { isWebsiteDApp } from '@/src/utils/constants';

type PropsDetailsTable = {
    fund: FundWithDetailsEntity;
    isTablet: boolean;
    isMobile: boolean;
};

export default function RowDetails(props: PropsDetailsTable) {
    const { fund, isTablet, isMobile } = props;
    //--------------------------------------
    const walletStore = useWalletStore();
    //--------------------------------------
    const tokensStore = useTokensStore();
    //--------------------------------------
    const [delegated, setDelegated] = useState<bigint | undefined>();
    //--------------------------------------
    useEffect(() => {
        if (walletStore.isWalletDataLoading === false && walletStore.isWalletDataLoaded === true) {
            if (walletStore.info && walletStore.delegations) {
                const totalStaked = walletStore.delegations
                    .filter((delegation) => delegation.ddFundPolicy_CS === fund.getNET_id_CS())
                    .reduce((acc, delegation) => acc + delegation.ddStaked, 0n);

                setDelegated(totalStaked);
            } else {
                setDelegated(0n);
            }
        } else {
            setDelegated(undefined);
        }
    }, [walletStore.isWalletDataLoaded, walletStore.isWalletDataLoading]);
    //--------------------------------------
    if (isTablet) {
        return (
            <article className={`${styles.rowDetails}`}>
                {isMobile ? (
                    <>
                        <section className={styles.row}>
                            <div className={styles.col}>
                                <p className={styles.title}>Change 24h</p>
                                <p className={`${styles.value} ${fund.change24 !== undefined ? (fund.change24 < 0 ? styles.negative : styles.positive) : styles.positive}`}>
                                    {fund.change24 !== undefined ? formatPercentage(fund.change24, 2) : '...'}
                                </p>
                            </div>
                            <div className={styles.col}>
                                <p className={styles.title}>Supply</p>
                                <p className={styles.value}>{showToken_Amount_Rounded(tokensStore, fund.total_FT_Minted, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}</p>
                            </div>
                        </section>
                        <section className={styles.row}>
                            <div className={styles.col}>
                                <p className={styles.title}>TVL</p>
                                <p className={styles.value}>{showADA_Amount_Rounded(tokensStore, getNumberx1e6(fund.TVLx1e6))}</p>
                            </div>
                            {isWebsiteDApp && (
                                <div className={styles.col}>
                                    <p className={styles.title}>Staked</p>
                                    <p className={styles.value}>{showTokenGov_Amount_Rounded(tokensStore, fund.staked)}</p>
                                </div>
                            )}
                        </section>
                    </>
                ) : (
                    <>
                        <section className={styles.row}>
                            <div className={styles.col}>
                                <p className={styles.title}>Supply</p>
                                <p className={styles.value}>{showToken_Amount_Rounded(tokensStore, fund.total_FT_Minted, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}</p>
                            </div>
                            <div className={styles.col}>
                                <p className={styles.title}>TVL</p>
                                <p className={styles.value}>{showADA_Amount_Rounded(tokensStore, getNumberx1e6(fund.TVLx1e6))}</p>
                            </div>
                        </section>
                        {isWebsiteDApp && (
                            <section className={styles.row}>
                                <div className={styles.col}>
                                    <p className={styles.title}>Staked</p>
                                    <p className={styles.value}>{showTokenGov_Amount_Rounded(tokensStore, fund.staked)}</p>
                                </div>
                                <div className={styles.col}>
                                    <p className={styles.title}>Earned Fees</p>
                                    <p className={styles.value}>{showToken_Amount_Rounded(tokensStore, fund.feeEarned, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}</p>
                                </div>
                            </section>
                        )}
                    </>
                )}
                <section className={styles.row}>
                    <div className={styles.col}>
                        <p className={styles.title}>My Participation</p>
                        <p className={styles.value}>
                            {showToken_Amount_Rounded(
                                tokensStore,
                                BigInt(walletStore.getTotalOfUnit(fund.getNET_id_CS() + fund.fdFundFT_TN_Hex)),
                                fund.getNET_id_CS(),
                                fund.fdFundFT_TN_Hex
                            )}
                        </p>
                    </div>
                    <div className={styles.col}>
                        <p className={styles.title}>My Valuation</p>
                        <p className={styles.value}>
                            {showToken_Price_MultipliedByAmount_Rounded(
                                tokensStore,
                                BigInt(walletStore.getTotalOfUnit(fund.getNET_id_CS() + fund.fdFundFT_TN_Hex)),
                                fund.getNET_id_CS(),
                                fund.fdFundFT_TN_Hex
                            )}
                        </p>
                    </div>
                </section>
                <section className={styles.row}>
                    {isWebsiteDApp && (
                        <div className={styles.col}>
                            <p className={styles.title}>My Stakek</p>
                            <p className={styles.value}>{showTokenGov_Amount_Rounded(tokensStore, delegated)}</p>
                        </div>
                    )}
                    <div className={styles.col}>
                        <MoreDetailsHome fund={fund} />
                    </div>
                </section>
            </article>
        );
    } else {
        return (
            <article className={`${styles.rowDetails}`}>
                <div className={`${styles.rowItem} ${styles.participation}`}>
                    <p className={styles.title}>My Participation</p>
                    <p className={styles.value}>
                        {showToken_Amount_Rounded(
                            tokensStore,
                            BigInt(walletStore.getTotalOfUnit(fund.getNET_id_CS() + fund.fdFundFT_TN_Hex)),
                            fund.getNET_id_CS(),
                            fund.fdFundFT_TN_Hex
                        )}
                    </p>
                </div>

                <div className={styles.sepLine}></div>
                <div className={`${styles.rowItem} ${styles.participation}`}>
                    <p className={styles.title}>My Valuation</p>
                    <p className={styles.value}>
                        {showToken_Price_MultipliedByAmount_Rounded(
                            tokensStore,
                            BigInt(walletStore.getTotalOfUnit(fund.getNET_id_CS() + fund.fdFundFT_TN_Hex)),
                            fund.getNET_id_CS(),
                            fund.fdFundFT_TN_Hex
                        )}
                    </p>
                </div>
                <div className={styles.sepLine}></div>
                {isWebsiteDApp && (
                    <>
                        <div className={styles.rowItem}>
                            <p className={styles.title}>My Stake</p>
                            <p className={styles.value}>{showTokenGov_Amount_Rounded(tokensStore, delegated)}</p>
                        </div>
                        <div className={styles.sepLine}></div>
                    </>
                )}

                <MoreDetailsHome fund={fund} />
            </article>
        );
    }
}
